var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPromosIcon = function SvgPromosIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "33px",
    viewBox: "0 0 25 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V1---internal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-14",
    transform: "translate(-1244.000000, -894.000000)",
    stroke: "#E74C3C"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(1122.000000, 895.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(123.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Asset-5-Copy-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    strokeWidth: 2,
    points: "20.7432451 19.5953392 20.7432451 5.90338118 11.5221609 0.140655964 2.31972479 5.90338118 2.31972479 12.7142857"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 11.52,
    cy: 5.85714286,
    rx: 1.152,
    ry: 1.14285714
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    strokeWidth: 2,
    points: "2.304 30.4345521 20.736 30.4345521 20.736 23.1566228 2.304 16.3279646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.524927948,12.0624898 L22.4685652,20.2107711",
    id: "Path",
    strokeWidth: 2
  }))))))));
};
export default SvgPromosIcon;